module.exports = __webpack_public_path__ + "static/media/evangelion_screen2.ece7a0a5.gif";